<template>
    <!-- Like button -->    
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Add Recipe</p>
            <div class="is-pulled-right">
                <router-link class="button is-primary" :to="{name: 'adapt', params: {id: selectedRecipe}}">  
                    <b-icon icon="utensils" size="is-small"></b-icon>&nbsp;&nbsp;Make it your own!
                </router-link>
            </div>
        </header>
        <section class="modal-card-body">        
        <b-tabs v-model="activeTab" size="is-large" class="add-to-tab block">
            <b-tab-item label="Meals">
                <div class="has-text-centered" v-if="userMeals.length === 0">
                    <h3 class="is-size-4">You don't have any meals in your kitchen yet. Add one below</h3>
                    <b-icon pack="fas" icon="arrow-down"></b-icon>
                </div>
                <div aria-role="listitem" class="add-to-item" v-for="meal in userMeals" :key="meal.id" @click="selectMeal({ recipe_id:selectedRecipe, meal_id:meal.id })">
                {{meal.name}}
                </div>
                <div aria-role="listitem" :focusable="false" custom paddingless class="mt-20">
                    <b-collapse aria-id="contentForNewMeal" :open="false" position="is-top">
                        <div
                            slot="trigger" 
                            slot-scope="props"
                            role="button"
                            aria-controls="contentForNewMeal">
                            <b-button type="is-primary" :icon-right="props.open ? 'minus' : 'plus'" style="width:100%;" />
                        </div>
                        <div class="mt-20 mb-20">
                            <div class="content">
                                <b-field label="Meal Name" class="add-meal-input">
                                    <b-input v-model="newMealName"></b-input>
                                </b-field>
                                <b-field label="Meal Description" class="add-meal-input">
                                    <b-input v-model="newMealSubtitle"></b-input>
                                </b-field>
                                <div class="content is-size-6">
                                    <strong>Meal Type</strong>
                                    <b-field>
                                        <b-radio-button v-model="mealType"
                                            v-for="meal in mealTypeArray" :key="meal"
                                            :native-value="meal"
                                            type="is-danger">
                                            <span>{{meal}}</span>
                                        </b-radio-button>
                                    </b-field>
                                    </div>
                            </div>
                        </div>
                        <b-button type="is-primary" @click="newMeal(selectedRecipe)" style="width:100%;">Save</b-button>
                    </b-collapse>
                </div>
            </b-tab-item>

            <b-tab-item label="Menus">
                <div class="has-text-centered" v-if="menus.length === 0">
                    <h3 class="is-size-4">You don't have any menus in your kitchen yet. Add one below</h3>
                    <b-icon pack="fas" icon="arrow-down"></b-icon>
                </div>
                <div aria-role="listitem" class="add-to-item" v-for="menu in menus" :key="menu.id" @click="selectMenu({ recipe_id:selectedRecipe, menu_id:menu.id })">
                {{menu.name}}
                </div>
                <div aria-role="listitem" :focusable="false" custom paddingless class="mt-20">
                    <b-collapse aria-id="contentForNewMeal" :open="false" position="is-top">
                        <div
                            slot="trigger" 
                            slot-scope="props"
                            role="button"
                            aria-controls="contentForNewMeal">
                            <b-button type="is-primary" :icon-right="props.open ? 'minus' : 'plus'" style="width:100%;" />
                        </div>
                        <div class="mt-20 mb-20">
                            <div class="content">
                                <b-field label="Menu Name" class="add-meal-input">
                                    <b-input v-model="newMenuName"></b-input>
                                </b-field>
                                <b-field label="Menu Description" class="add-meal-input">
                                    <b-input v-model="newMenuSubtitle"></b-input>
                                </b-field>
                            </div>
                        </div>
                            <b-button type="is-primary" @click="newMenu(selectedRecipe)" style="width:100%;">Save</b-button>
                    </b-collapse>
                </div>
            </b-tab-item>
        </b-tabs>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Close</button>
        </footer>
    </div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';        

export default {
    data() {
        return {
            newMealName: null,
            newMealSubtitle: null,
            newMealRef: Object,
            newMenuName: null,
            newMenuSubtitle: null,
            newMenuRef: Object,
            activeTab: 0,
            mealType: null,
            mealTypeArray: [],
            user_id: firebase.auth().currentUser.uid
        };
    },
    props: {
        userMeals: {
            type: Array,
            required: true
        },
        menus: {
            type: Array,
            required: true
        },
        selectedRecipe: {
            type: String,
            required: true
        },
        userData: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.newMealRef = db.collection("recipes").doc();
        this.getMealTypes();
    },
    methods: {
        selectMeal({ meal_id, recipe_id }) {  
            let recipe;  
            // let user_id = firebase.auth().currentUser.uid;
             db.collection('recipes').doc(recipe_id).get().then(docSnapshot => {  
                 if (!docSnapshot.exists) return;
                 recipe = docSnapshot.data();
            }).then(()=>{
                    db.collection('meals').doc(meal_id).get().then(docSnapshot => {
                    if (!docSnapshot.exists) return;
                    var mealRef = db.collection("meals").doc(meal_id);
                    var valObj = docSnapshot.data().recipes.filter(function(elem){
                        if(elem.id == recipe.id) return elem.id;
                    });

                    if(valObj.length > 0) {
                        let errorMessage = "This recipe already exists in your meal";
                        this.addError(errorMessage)
                    }
                    else {
                        let cookMinutes = 0;
                        let prepMinutes = 0;
                        cookMinutes = (parseInt(recipe.cookTime.minutes) + parseInt(recipe.cookTime.hours * 60) + parseInt(docSnapshot.data().cookTime.minutes) + parseInt(docSnapshot.data().cookTime.hours * 60));
                        prepMinutes = (parseInt(recipe.prepTime.minutes) + parseInt(recipe.prepTime.hours * 60) + parseInt(docSnapshot.data().prepTime.minutes) + parseInt(docSnapshot.data().prepTime.hours * 60));
                        
                        return mealRef.update({
                            recipes: firebase.firestore.FieldValue.arrayUnion(recipe),
                            cookTime: {
                                hours: Math.floor(cookMinutes / 60),
                                minutes: cookMinutes % 60
                            },
                            prepTime: {
                                hours: Math.floor(prepMinutes / 60),
                                minutes: prepMinutes % 60
                            },
                        })
                        .then(() => {
                            let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                            db.collection('users').doc(this.user_id).get().then((doc) => {
                                if (doc.exists) {                            
                                    newNotificationRef.set({
                                        id:newNotificationRef.id,
                                        user_id: this.userData.id,
                                        type:'meal',
                                        typeId:meal_id,
                                        kitchen_name: this.userData.kitchen_name,
                                        read:false,
                                        message: this.userData.kitchen_name + ' Added your recipe for ' + recipe.name + ' to their meal!'
                                    })
                                }
                            }).catch(function(error) {
                                console.log("Error getting document:", error);
                            });
                            // console.log("Document successfully updated!");
                            this.addSuccess('Your meal has been saved');
                            this.$router.replace("/edit-meal/"+meal_id);
                            this.$parent.close();
                        })
                        .catch(function(error) {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);
                        });
                        
                    }
                }); 
            })
            
        }, 
        newMeal(recipe_id) {
            if(!this.newMealName) {
                return this.addError('Your meal needs a title');
            }
            else if(!this.mealType) {
                return this.addError('Your meal needs a meal type');
            }
            else {
                let recipe;    
                db.collection('recipes').doc(recipe_id).get().then(docSnapshot => {  
                    if (!docSnapshot.exists) return;
                    recipe = docSnapshot.data();
                }).then(() => {
                    let slug = this.sanitizeTitle(this.newMealName);
                    let created_at = new Date();
                    let newMealRef = db.collection('meals').doc();
                    // let user_id = firebase.auth().currentUser.uid;

                    if(this.userMeals.filter(meal => meal.name == this.newMealName).length > 0) {
                        let errorMessage = "You already have a meal titled " + this.newMealName;
                        this.addError(errorMessage)
                    }
                    else {
                    newMealRef
                        .set({
                            id:newMealRef.id,
                            name:this.newMealName,
                            subtitle:this.newMealSubtitle,
                            recipes: firebase.firestore.FieldValue.arrayUnion(recipe),
                            user_id: this.user_id,
                            kitchen_name:this.userData.kitchen_name,
                            mainImage: null,
                            mealType: this.mealType,
                            cookTime: {
                                hours: recipe.cookTime.hours,
                                minutes: recipe.cookTime.minutes
                            },
                            prepTime: {
                                hours: recipe.prepTime.hours,
                                minutes: recipe.prepTime.minutes
                            },
                            slug: slug,
                            created_at: created_at,
                        });
                        let meal_id = newMealRef.id;  
                        db.collection('mealType').where(meal_id,'==',true)
                            .get().then(function(querySnapshot) {
                                querySnapshot.forEach(function(doc) {
                                doc.ref.update({[meal_id]:null});
                                });
                            });
                        db.collection("mealType").where("name", "==", this.mealType)
                            .get()
                            .then(function(querySnapshot) {
                                querySnapshot.forEach(function(doc) {
                                    // console.log(doc.id, " => ", doc.data());
                                    // Build doc ref from doc.id
                                    db.collection("mealType").doc(doc.id).update({[meal_id]:true})
                                });
                            })
                            .catch(function(error) {
                                console.log("Error getting documents: ", error);
                            });

                    let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                        db.collection('users').doc(this.user_id).get().then((doc) => {
                            if (doc.exists) {                            
                                newNotificationRef.set({
                                    id:newNotificationRef.id,
                                    user_id: this.userData.id,
                                    type:'meal',
                                    typeId:meal_id,
                                    kitchen_name: this.userData.kitchen_name,
                                    read:false,
                                    message: this.userData.kitchen_name + ' Added your recipe for ' + recipe.name + ' to their meal!'
                                })
                            }
                        }).catch(function(error) {
                            console.log("Error getting document:", error);
                        });
                    }
                    this.addSuccess('Your meal has been saved');
                    this.$router.replace("/edit-meal/"+newMealRef.id);
                    this.$parent.close();
                })
                
            }
        },
        selectMenu({ menu_id, recipe_id }) {  
            let recipe;    
             db.collection('recipes').doc(recipe_id).get().then(docSnapshot => {  
                 if (!docSnapshot.exists) return;
                 recipe = docSnapshot.data();
            }).then(() => {
                db.collection('menus').doc(menu_id).get().then(docSnapshot => {
                    if (!docSnapshot.exists) return;
                    let menuRef = db.collection("menus").doc(menu_id);
                    let menu = docSnapshot.data();
                    let menuRecipes = menu.menu;
                    let valObj = false;
                    for(let i=0;i<menuRecipes.length;i++) {
                        
                        if(menuRecipes[i].dishType == recipe.dishType) {                        
                            let current_recipe = menuRecipes[i].recipes;
                            for(let j=0;j<current_recipe.length;j++) {
                                if (current_recipe[j].id == recipe.id) {
                                    valObj = true;
                                }
                            }                      

                            if(valObj) {
                                let errorMessage = "This recipe already exists in your menu";
                                return this.addError(errorMessage);
                            }
                            else {
                                menu.menu[i].recipes.push(recipe); 

                                let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                                db.collection('users').doc(this.user_id).get().then((doc) => {
                                    if (doc.exists) {                            
                                        newNotificationRef.set({
                                            id:newNotificationRef.id,
                                            user_id: this.userData.id,
                                            type:'menu',
                                            typeId:menu_id,
                                            kitchen_name: this.userData.kitchen_name,
                                            read:false,
                                            message: this.userData.kitchen_name + ' Added your recipe for ' + recipe.name + ' to their menu!'
                                        })
                                    }
                                }).catch(function(error) {
                                    console.log("Error getting document:", error);
                                });

                                this.addSuccess('Your menu has been saved');
                                this.$parent.close();
                                return menuRef.update({
                                    menu: menu.menu
                                })
                            }
                        }
                    }

                    let recipeArray = [recipe];
                    let recipeIndex = {
                            dishType: recipe.dishType,
                            recipes: recipeArray
                        };
                    menu.menu.push(recipeIndex);

                    let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                        db.collection('users').doc(this.user_id).get().then((doc) => {
                            if (doc.exists) {                            
                                newNotificationRef.set({
                                    id:newNotificationRef.id,
                                    user_id: this.userData.id,
                                    type:'menu',
                                    typeId:menu_id,
                                    kitchen_name: this.userData.kitchen_name,
                                    read:false,
                                    message: this.userData.kitchen_name + ' Added your recipe for ' + recipe.name + ' to their menu!'
                                })
                            }
                        }).catch(function(error) {
                            console.log("Error getting document:", error);
                        });

                    this.addSuccess('Your menu has been saved');
                    this.$parent.close();
                    return menuRef.update({
                        menu: firebase.firestore.FieldValue.arrayUnion(recipeIndex)
                    })
                    .then(() => {
                            this.$router.replace("/edit-menu/"+menu_id);
                        })
                        .catch(function(error) {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);
                        });

                });
            })      
             
        }, 
        newMenu(recipe_id) {
            if(!this.newMenuName) {
                return this.addError('Your menu needs a title');
            }
            else {
                let recipe;    
                db.collection('recipes').doc(recipe_id).get().then(docSnapshot => {  
                    if (!docSnapshot.exists) return;
                    recipe = docSnapshot.data();
                }).then(()=> {
                    let slug = this.sanitizeTitle(this.newMenuName);
                    let created_at = new Date();
                    let newMenuRef = db.collection('menus').doc();
                    // let user_id = firebase.auth().currentUser.uid;
                    let recipeArray = [recipe];
                    let recipeIndex = [{
                            dishType: recipe.dishType,
                            recipes: recipeArray
                        }
                    ];

                    if(this.menus.filter(menu => menu.name == this.newMenuName).length > 0) {
                        let errorMessage = "You already have a menu titled " + this.newMenuName;
                        this.addError(errorMessage)
                    }
                    else {
                    newMenuRef
                        .set({
                            id:newMenuRef.id,
                            name:this.newMenuName,
                            subtitle:this.newMenuSubtitle,
                            menu: recipeIndex,
                            user_id: this.user_id,
                            kitchen_name:this.userData.kitchen_name,
                            mainImage: null,
                            slug: slug,
                            created_at: created_at,
                        });
                        let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                        db.collection('users').doc(this.user_id).get().then((doc) => {
                            if (doc.exists) {                            
                                newNotificationRef.set({
                                    id:newNotificationRef.id,
                                    user_id: this.userData.id,
                                    type:'menu',
                                    typeId:newMenuRef.id,
                                    kitchen_name: this.userData.kitchen_name,
                                    read:false,
                                    message: this.userData.kitchen_name + ' Added your recipe for ' + recipe.name + ' to their menu!'
                                })
                            }
                        }).catch(function(error) {
                            console.log("Error getting document:", error);
                        });


                    }
                    this.addSuccess('Your menu has been saved');
                    this.$router.replace("/edit-menu/"+newMenuRef.id);
                    this.$parent.close();
                })                
            }
        },
        sanitizeTitle: function(title) {
            var slug = "";
            // Change to lower case
            var titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s+/g, '-');            
            return slug;
        },
        async getMealTypes() {
            // get the collection
            const mealType = db.collection('mealType')
            const { docs } = await mealType.get()
            // map all documents to the object
            docs.map(doc => {
                this.mealTypeArray.push(doc.data().name)
            })
        },
        addError(errorMessage) {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: errorMessage,
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            },
        addSuccess(successMessage) {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: successMessage,
                    position: 'is-bottom',
                    type: 'is-success'
                })
            }
    }
};
</script>